import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
// import { TranslateService } from "@ngx-translate/core";  //test
import { ConfigService } from '../../shared/services/config.service';
import { DOCUMENT } from '@angular/common';
import { LayoutService } from '../../shared/services/layout.service';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { takeUntil } from 'rxjs/operators';
import { NavigatorService } from 'src/app/shared/navigator';

const fireRefreshEventOnWindow = (): void => {
  const evt = document.createEvent('HTMLEvents');
  evt.initEvent('resize', true, false);
  window.dispatchEvent(evt);
};

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  @ViewChild('sidebarBgImage', { static: true }) sidebarBgImage: ElementRef;
  @ViewChild('appSidebar', { static: true }) appSidebar: ElementRef;
  @ViewChild('wrapper', { static: true }) wrapper: ElementRef;

  options = {
    direction: 'ltr',
    bgColor: 'black',
    bgImage: 'assets/img/sidebar-bg/01.jpg',
  };
  hideSidebar: boolean;
  iscollapsed = false;
  isSidebarSm = false;
  isSidebarLg = false;
  bgColor = 'black';
  bgImage = 'assets/img/sidebar-bg/01.jpg';

  public config: any = {};

  paths$ = this._navigatorService.paths$;

  constructor(
    private _layoutService: LayoutService,
    private _configService: ConfigService,
    @Inject(DOCUMENT) private _document: Document,
    private _renderer: Renderer2,
    public loaderService: LoaderService, // private _cdr: ChangeDetectorRef,
    private _navigatorService: NavigatorService,
  ) {
    // event emitter call from customizer
    this._layoutService.customizerChangeEmitted$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((options) => {
        if (options) {
          if (options.bgColor) {
            this.bgColor = options.bgColor;
          }

          if (options.bgImage) {
            this.bgImage = options.bgImage;
            this._renderer.setAttribute(
              this.sidebarBgImage.nativeElement,
              'style',
              'background-image: url("' + this.bgImage + '")',
            );
          }

          if (options.bgImageDisplay === true) {
            this.bgImage = options.bgImage;
            this._renderer.setAttribute(
              this.sidebarBgImage.nativeElement,
              'style',
              'display: block; background-image: url("' + this.bgImage + '")',
            );
          } else if (options.bgImageDisplay === false) {
            this.bgImage = '';
            // this._renderer.setAttribute(this.sidebarBgImage.nativeElement, 'style', 'display: none');
            this._renderer.setAttribute(
              this.sidebarBgImage.nativeElement,
              'style',
              'background-image: none',
            );
          }

          if (options.compactMenu === true) {
            this._renderer.addClass(
              this.wrapper.nativeElement,
              'nav-collapsed',
            );
            this._renderer.addClass(
              this.wrapper.nativeElement,
              'menu-collapsed',
            );
          } else if (options.compactMenu === false) {
            if (
              this.wrapper.nativeElement.classList.contains('nav-collapsed')
            ) {
              this._renderer.removeClass(
                this.wrapper.nativeElement,
                'nav-collapsed',
              );
              this._renderer.removeClass(
                this.wrapper.nativeElement,
                'menu-collapsed',
              );
            }
          }

          if (options.sidebarSize === 'sidebar-lg') {
            this.isSidebarSm = false;
            this.isSidebarLg = true;
          } else if (options.sidebarSize === 'sidebar-sm') {
            this.isSidebarSm = true;
            this.isSidebarLg = false;
          } else {
            this.isSidebarSm = false;
            this.isSidebarLg = false;
          }

          if (options.layout === 'Light') {
            this._renderer.removeClass(this._document.body, 'layout-dark');
            this._renderer.removeClass(
              this._document.body,
              'layout-transparent',
            );
            this._renderer.removeClass(this._document.body, 'bg-hibiscus');
            this._renderer.removeClass(
              this._document.body,
              'bg-purple-pizzazz',
            );
            this._renderer.removeClass(this._document.body, 'bg-blue-lagoon');
            this._renderer.removeClass(
              this._document.body,
              'bg-electric-violet',
            );
            this._renderer.removeClass(this._document.body, 'bg-portage');
            this._renderer.removeClass(this._document.body, 'bg-tundora');
            this._renderer.removeClass(this._document.body, 'bg-glass-1');
            this._renderer.removeClass(this._document.body, 'bg-glass-2');
            this._renderer.removeClass(this._document.body, 'bg-glass-3');
            this._renderer.removeClass(this._document.body, 'bg-glass-4');
          } else if (options.layout === 'Dark') {
            if (this._document.body.classList.contains('layout-transparent')) {
              this._renderer.removeClass(
                this._document.body,
                'layout-transparent',
              );
              this._renderer.removeClass(this._document.body, 'bg-hibiscus');
              this._renderer.removeClass(
                this._document.body,
                'bg-purple-pizzazz',
              );
              this._renderer.removeClass(this._document.body, 'bg-blue-lagoon');
              this._renderer.removeClass(
                this._document.body,
                'bg-electric-violet',
              );
              this._renderer.removeClass(this._document.body, 'bg-portage');
              this._renderer.removeClass(this._document.body, 'bg-tundora');
              this._renderer.removeClass(this._document.body, 'bg-glass-1');
              this._renderer.removeClass(this._document.body, 'bg-glass-2');
              this._renderer.removeClass(this._document.body, 'bg-glass-3');
              this._renderer.removeClass(this._document.body, 'bg-glass-4');

              this._renderer.addClass(this._document.body, 'layout-dark');
            } else {
              this._renderer.addClass(this._document.body, 'layout-dark');
            }
          } else if (options.layout === 'Transparent') {
            this._renderer.addClass(this._document.body, 'layout-transparent');
            this._renderer.addClass(this._document.body, 'layout-dark');
            this._renderer.addClass(this._document.body, 'bg-glass-1');
          }

          if (options.transparentColor) {
            this._renderer.removeClass(this._document.body, 'bg-hibiscus');
            this._renderer.removeClass(
              this._document.body,
              'bg-purple-pizzazz',
            );
            this._renderer.removeClass(this._document.body, 'bg-blue-lagoon');
            this._renderer.removeClass(
              this._document.body,
              'bg-electric-violet',
            );
            this._renderer.removeClass(this._document.body, 'bg-portage');
            this._renderer.removeClass(this._document.body, 'bg-tundora');
            this._renderer.removeClass(this._document.body, 'bg-glass-1');
            this._renderer.removeClass(this._document.body, 'bg-glass-2');
            this._renderer.removeClass(this._document.body, 'bg-glass-3');
            this._renderer.removeClass(this._document.body, 'bg-glass-4');
            this._renderer.addClass(
              this._document.body,
              options.transparentColor,
            );
          }
        }
      });
  }

  ngOnInit(): void {
    this.config = this._configService.templateConf;
    this.bgColor = this.config.layout.sidebar.backgroundColor;

    if (!this.config.layout.sidebar.backgroundImage) {
      this.bgImage = '';
    } else {
      this.bgImage = this.config.layout.sidebar.backgroundImageURL;
    }

    if (this.config.layout.variant === 'Transparent') {
      if (this.config.layout.sidebar.backgroundColor.toString().trim() === '') {
        this.bgColor = 'bg-glass-1';
      }
    } else {
      if (this.config.layout.sidebar.backgroundColor.toString().trim() === '') {
        this.bgColor = 'black';
      }
    }

    setTimeout((): void => {
      if (this.config.layout.sidebar.size === 'sidebar-lg') {
        this.isSidebarSm = false;
        this.isSidebarLg = true;
      } else if (this.config.layout.sidebar.size === 'sidebar-sm') {
        this.isSidebarSm = true;
        this.isSidebarLg = false;
      } else {
        this.isSidebarSm = false;
        this.isSidebarLg = false;
      }

      this.iscollapsed = this.config.layout.sidebar.collapsed;
    }, 0);

    // emit event to customizer
    this.options.bgColor = this.bgColor;
    this.options.bgImage = this.bgImage;

    this._layoutService.emitCustomizerChange(this.options);

    // customizer events
    // this.elementRef.nativeElement
    //   .querySelector('#cz-compact-menu')
    //   .addEventListener('click', this.onClick.bind(this));
    // this.elementRef.nativeElement
    //   .querySelector('#cz-sidebar-width')
    //   .addEventListener('click', this.onClick.bind(this));
  }

  ngAfterViewInit(): void {
    setTimeout((): void => {
      if (this.config.layout.dir) {
        this.options.direction = this.config.layout.dir;
      }

      if (this.config.layout.variant === 'Dark') {
        this._renderer.addClass(this._document.body, 'layout-dark');
      } else if (this.config.layout.variant === 'Transparent') {
        this._renderer.addClass(this._document.body, 'layout-dark');
        this._renderer.addClass(this._document.body, 'layout-transparent');

        if (this.config.layout.sidebar.backgroundColor) {
          this._renderer.addClass(
            this._document.body,
            this.config.layout.sidebar.backgroundColor,
          );
        } else {
          this._renderer.addClass(this._document.body, 'bg-glass-1');
        }

        this.bgColor = 'black';
        this.options.bgColor = 'black';
        this.bgImage = '';
        this.options.bgImage = '';
        this.bgImage = '';
        this._renderer.setAttribute(
          this.sidebarBgImage.nativeElement,
          'style',
          'background-image: none',
        );
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  onClick(): void {
    // initialize window resizer event on sidebar toggle click event
    setTimeout((): void => {
      fireRefreshEventOnWindow();
    }, 300);
  }

  toggleHideSidebar($event: boolean): void {
    setTimeout((): void => {
      this.hideSidebar = $event;
    }, 0);
  }

  getOptions($event): void {
    this.options = $event;
  }
}
